import { get, makeConstructUrlFromQuery } from './apiUtils';

const defaultUrl = '/stats/';
const getUrl = makeConstructUrlFromQuery(defaultUrl);

export default {
  getAllStats: query => get(getUrl({ query })),
};
